import React from "react";
import { ArrowDown } from "react-feather";
import { getIcon, getLink } from "../../utils";
import notableAlumni from "../../utils/alumni";
import "./alumnus.scss";

const Alumnus = ({ image, name, works, socials, index }) => {
	return (
		<section
			className="notable-alumni-alumnus"
			key={index}
			style={{
				backgroundImage: `url(${image})`,
			}}
		>
			<div className="notable-alumni-alumnus__name">
				<h1 data-aos="fade-right">{name}</h1>
			</div>
			<div className="notable-alumni-alumnus__works">
				<h2>Notable Works</h2>
				<ul
					data-aos="fade-up"
					className="notable-alumni-alumnus__works-list"
				>
					{works.map((work, index) => (
						<li key={index}>{work}</li>
					))}
				</ul>
			</div>
			<div className="notable-alumni-alumnus__socials">
				{socials.map((social, index) => (
					<a
						href={getLink(social.service, social.username)}
						target="_blank"
						rel="noreferrer"
						className="notable-alumni-alumnus__social"
						title={social.service}
						key={index}
					>
						<span className="notable-alumni-alumnus__social-icon">
							{getIcon(social.service)}
						</span>
					</a>
				))}
			</div>
			{index !== notableAlumni.length - 1 && (
				<button
					className="notable-alumni-alumnus__scroll-down"
					onClick={() =>
						window.scrollTo(0, window.innerHeight * (index + 2))
					}
				>
					<ArrowDown />
				</button>
			)}
		</section>
	);
};

export default Alumnus;
